import { useCallback, useState } from "react";

import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";

interface DeleteViewDialogProps {
  isOpen: boolean;
  viewName: string;
  onClose: () => void;
  onDelete: () => Promise<void>;
}

const DeleteViewDialog = ({
  isOpen,
  viewName,
  onClose,
  onDelete,
}: DeleteViewDialogProps) => {
  const { l10n } = useLocalization();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = useCallback(async () => {
    setIsDeleting(true);
    try {
      await onDelete();
    } finally {
      setIsDeleting(false);
    }
  }, [onDelete]);

  return (
    <Dialog
      isOpen={isOpen}
      title={l10n.getString("delete-view-dialog-title", { name: viewName })}
      onUserDismiss={onClose}
      testId="delete-view-dialog"
      footer={
        <Row alignItems="center" justifyContent="end" gapSize="s">
          <Row.Item shrink>
            <Button
              kind="plain"
              label={l10n.getString("delete-view-dialog-button-close")}
              onClick={onClose}
              testId="delete-view-dialog-close"
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              kind="primary"
              label={l10n.getString("delete-view-dialog-button-delete")}
              onClick={handleDelete}
              disabled={isDeleting}
              isLoading={isDeleting}
              testId="delete-view-dialog-delete"
            />
          </Row.Item>
        </Row>
      }
    >
      {l10n.getString("delete-view-dialog-description")}
    </Dialog>
  );
};

export default DeleteViewDialog;
